import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { GHAAccountType, getGHAEffectiveDiscount } from '~/services/ConnectionGoogleService';

export const ghaEffectiveDiscountQueryKeys = {
  all: ['ghaEffectiveDiscounts'] as const,
  property: (propertyId: string, accountType?: GHAAccountType) =>
    [...ghaEffectiveDiscountQueryKeys.all, 'property', propertyId, accountType] as const,
};

// Resolutions reflect live rule state; a short staleTime keeps tab/account flips cheap without
// hiding fresh rule edits for long. keepPreviousData avoids flashing to a spinner on switches
// (same pattern as the scope-rule and property lists).
const EFFECTIVE_DISCOUNT_STALE_MS = 60 * 1000;

export function useGHAEffectiveDiscount(propertyId: string, accountType: GHAAccountType | undefined) {
  return useQuery({
    queryKey: ghaEffectiveDiscountQueryKeys.property(propertyId, accountType),
    queryFn: async ({ signal }) => {
      const response = await getGHAEffectiveDiscount(propertyId, { accountType }, { signal });
      return response.result;
    },
    enabled: !!accountType,
    staleTime: EFFECTIVE_DISCOUNT_STALE_MS,
    placeholderData: keepPreviousData,
  });
}
